import http from "@/api/http-common";

function getApiClient(userType) {
  return http.getApiClient(userType);
}

function getAuthenticatedParams(user, extraParams = {}) {
  return {
    id: user.id,
    key: user.key,
    ...extraParams
  };
}

function getWalletDateRangeParams(user, from, to) {
  return getAuthenticatedParams(user, { from, to });
}

export function fetchOrders(userType, user, from, to) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_orders",
      ...getWalletDateRangeParams(user, from, to)
    }
  });
}

export function fetchOrdersBrief(userType, user, from, to) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_orders_brief",
      ...getWalletDateRangeParams(user, from, to)
    }
  });
}

export function fetchTrades(userType, user, from, to) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_trades",
      ...getWalletDateRangeParams(user, from, to)
    }
  });
}

export function fetchTransactions(userType, user, from, to) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_transactions",
      ...getWalletDateRangeParams(user, from, to)
    }
  });
}

export function fetchTransfers(userType, user, from, to) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_transfers",
      ...getWalletDateRangeParams(user, from, to)
    }
  });
}

export function fetchWallet(userType, user, date) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_wallet",
      ...getAuthenticatedParams(user, { d: date })
    }
  });
}

export function cancelOrder(userType, user, orderId) {
  return getApiClient(userType).get("", {
    params: {
      a: "cancel_order",
      ...getAuthenticatedParams(user, { oid: orderId })
    }
  });
}

export function fetchOrder(userType, user, orderId) {
  return getApiClient(userType).get("", {
    params: {
      a: "get_order",
      ...getAuthenticatedParams(user, { oid: orderId })
    }
  });
}
